// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_X99","cls2":"ArticlesFilters-cls2_1Qi ArticlesFilters-cls1_X99"};